/*
 * @Author: hippo
 * @Date: 2023-04-08 23:12:42
 * @LastEditors: hippo
 * @LastEditTime: 2023-12-08 11:31:21
 * @FilePath: /subang-console/src/containers/helps/index.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { List, Card } from 'antd';
import { Player } from 'video-react';
import React from 'react'
import "video-react/dist/video-react.css"
import { withQuery } from '@/utils'
function HelpVideoList(props) {


    const data = [
        {
          id: "1",
          title: '如何添加产品及工单配置填写',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%A6%82%E4%BD%95%E6%B7%BB%E5%8A%A0%E4%BA%A7%E5%93%81%E5%8F%8A%E5%B7%A5%E5%8D%95%E9%85%8D%E7%BD%AE%E5%A1%AB%E5%86%99.mp4'
        },
        {
          id: "2",
          title: '如何添加员工及员工权限设置',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%A6%82%E4%BD%95%E6%B7%BB%E5%8A%A0%E5%91%98%E5%B7%A5%E5%8F%8A%E5%91%98%E5%B7%A5%E6%9D%83%E9%99%90%E8%AE%BE%E7%BD%AE.mp4'
        },
        {
          id: "3",
          title: '如何充值及财务中心介绍',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%A6%82%E4%BD%95%E5%85%85%E5%80%BC%E5%8F%8A%E8%B4%A2%E5%8A%A1%E4%B8%AD%E5%BF%83%E4%BB%8B%E7%BB%8D.mp4'
        },
        {
          id: "4",
          title: '如何创建工单',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%A6%82%E4%BD%95%E5%88%9B%E5%BB%BA%E5%B7%A5%E5%8D%95.mp4'
        },
        {
          id: "5",
          title: '工单默认同意价格区间',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%B7%A5%E5%8D%95%E9%BB%98%E8%AE%A4%E5%90%8C%E6%84%8F%E4%BB%B7%E6%A0%BC%E5%8C%BA%E9%97%B4.mp4'
        },
        {
          id: "6",
          title: '工单查询与筛选',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%B7%A5%E5%8D%95%E6%9F%A5%E8%AF%A2%E4%B8%8E%E7%AD%9B%E9%80%89.mp4'
        },
        {
          id: "7",
          title: '工作台功能介绍',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%B7%A5%E4%BD%9C%E5%8F%B0%E5%8A%9F%E8%83%BD%E4%BB%8B%E7%BB%8D.mp4'
        },
        {
          id: "8",
          title: '工单申诉索赔',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%B7%A5%E5%8D%95%E7%94%B3%E8%AF%89%E7%B4%A2%E8%B5%94.mp4'
        },
        {
          id: "9",
          title: '推广返佣介绍',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E6%8E%A8%E5%B9%BF%E8%BF%94%E4%BD%A3%E4%BB%8B%E7%BB%8D.mp4'
        },
        {
          id: "10",
          title: '如何联系客服',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%A6%82%E4%BD%95%E8%81%94%E7%B3%BB%E5%AE%A2%E6%9C%8D.mp4'
        },
        {
          id: "11",
          title: '多账号管理',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%A4%9A%E8%B4%A6%E5%8F%B7%E7%AE%A1%E7%90%86.mp4'
        },
        {
          id: "12",
          title: '平台优势',
          url: 'https://xiaobingsubang.oss-cn-beijing.aliyuncs.com/product-video/%E7%BD%91%E7%AB%99%E6%8C%87%E5%AF%BC%E8%A7%86%E9%A2%91/%E5%B9%B3%E5%8F%B0%E4%BC%98%E5%8A%BF.mp4'
        },
      ];
    return (
        <div style={{marginLeft:50,marginRight:50,marginTop:20}}>
        <List
        grid={{
          gutter: 16,
          column: 3
        }}
        dataSource={data}
        renderItem={item => (
          <List.Item>
            <Card title={item.title}>
            <Player  videoId={item.id} src={item.url}>
            </Player>
            </Card>
          </List.Item>
        )}
      />
      </div>
    )
  }
  export default withQuery(HelpVideoList)